import Vue from 'vue'
import Vuex from 'vuex'

import firebase from '@/helpers/firebaseConfig'
import router from '../router'

const db = firebase.firestore()

Vue.use(Vuex)

export const store = new Vuex.Store({
	strict: true,
	state: {
		e1: 1,
		primary: "#000",
		success: "#3cd1c2",
		info: "#ffaa2c",
		user: null,
		newUser: null,
		loading: false,
		drawerMenu: false,
		error: null,
		counter: 0,
		users: [],
		groups: [],
		services: [],
		services2: [ 'HVAC',
		'ELECTRICAL',
		'PLUMBING',
		'DRAINS',
		],
		pricebook: [],
		presets: [],
		history: [],
		preview: {},
		company: {
			id: null,
			image: null,
			imageUrl: "",
			companyName: '',
			companyPhone: '',
			companyWebsite: '',
			emailMessage: 'Recommended Options To Help Improve The Comfort In Your Home',
			footer: 'Thank You Very Much For Your Business!',
			priceDisclosure: "*** Prices Include Tax, Labor, Parts & One Year Warranty"
			// imageUrl: "https://loremflickr.com/200/150",
		},
		discounts: [
		{
			"amount": '0',
			"title": 'None',
			"description": ""	
		}
		],
		priceNote: "*** Prices Include Tax, Labor, Parts & One Year Warranty",
		settingsDialog: false,
		signInDialog: false,
		snack: false,
		snackText: null,
		editedItem: {
			title: '',
			description: '',
			service: '',
			group: '',
			price: null,
			coupon: 0,
			id: '',
			editing: false
		}
	},
	mutations: {
		e1 (state, payload) {
			state.e1 = payload
		},
		setLoading (state, payload) {
			state.loading = payload
		},
		setError (state, payload) {
			state.error = payload
		},
		clearError (state) {
			state.error = null
		},
		counter(state, payload=1){
			state.counter += payload
		},
		clearNewUser (state, payload) {
			state.newUser = null
		},
		setPresets (state, payload) {
			state.presets.push(payload)
		},
		setDiscount (state, payload) {
			state.discounts.push(payload)
		},
		setHistory (state, payload) {
			state.history.push(payload)
		},
		clearPresets (state, payload){
			state.presets = new Array()
		},
		setPreview (state, payload){
			state.preview = payload
		},
		clearAll (state, payload) {
			state.company = new Array()
			state.pricebook = new Array()
			state.groups = new Array()
			state.presets = new Array()
			state.history = new Array()
			state.users = new Array()
		},
		logOut(state, payload) {
			console.log('something called this logOut Commit')
		},
		removeItem (state, payload) {
			state.pricebook.splice(payload, 1)
		},
		removeGroup (state, payload) {
			state.groups.splice(payload, 1)
		},
		removeHistory (state, payload) {
			state.history.splice(payload, 1)
		},
		removePreset (state, payload) {
			state.presets.splice(payload, 1)
		},
		removeDiscount (state, payload) {
			state.discounts.splice(payload, 1)
		},
		updateEditItemInfo (state, payload) {
			state.editedItem = Object.assign({}, payload)
		},
		updateItem (state, payload) {
			Object.assign(state.pricebook[payload.ind], payload.item)
		},
		updateGroup (state, payload) {
			Object.assign(state.groups[payload.ind], payload.item)
		},
		updateHistory (state, payload) {
			Object.assign(state.history[payload.ind], payload.item)
		},
		updateUser (state, payload) {
			Object.assign(state.users[payload.ind], payload.item)
		},
		createCompanyInfo (state, payload) {
			state.company = payload
		},
		drawerMenu (state, payload) {
			state.drawerMenu = payload
		},
		cId (state, payload){
			state.user.cId = payload
		},
		email (state, payload){
			state.user.email = payload
		},
		emailMessage (state, payload){
			state.company.emailMessage = payload
		},
		firstName (state, payload){
			state.user.firstName = payload
		},
		lastName (state, payload){
			state.user.lastName = payload
		},
		service (state, payload){
			state.user.service = payload
		},
		setImages (state, payload){
			state.pricebook.push(payload)
		},
		setSnack (state, payload){
			state.snackText = payload
			state.snack = !state.snack
		},
		settingsDialog (state, payload) {
			state.settingsDialog = payload 
		},
		signInDialog (state, payload){
			state.signInDialog = payload
		},
		image(state, payload){
			state.company.image = payload
		},
		imageUrl (state, payload){
			state.company.imageUrl = payload
		},
		companyWebsite (state, payload){
			state.company.companyWebsite = payload
		},
		companyPhone (state, payload){
			state.company.companyPhone = payload
		},
		companyName (state, payload){
			state.company.companyName = payload
		},
		footer (state, payload){
			state.company.footer = payload
		},
		priceDisclosure (state, payload){
			state.company.priceDisclosure = payload
		},
		setUser (state, payload) {
			state.user = payload
		},
		setUsers (state, payload){
			state.users.push(payload)
		},
		setAdmin (state, payload){
			state.user.admin = payload
		},
		setSuperAdmin (state, payload){
			state.user.superAdmin = payload
		},
		setGroups (state, payload){
			state.groups.push({...payload.data(), id: payload.id})
			state.groups.sort((a,b) => a < b ? -1 : 1)
		},
		setServices (state, payload){
			// console.log('******* PAYLOAD', payload.map(doc => doc.data()))
			// state.groups = [...new Set(payload.filter(doc => doc.data().service == state.user.service)
				// .map(doc => doc.data().group.toUpperCase() ) )]

			// state.groups.sort((a,b) => a < b ? -1 : 1)

			// state.groups = state.groups.map(doc => {
			// 	return {
			// 		name: doc,
			// 		groupImage: 'https://picsum.photos/200/300'
			// 	}
			// })
			// console.log('state groups', state.groups)

			// get services and order
			state.services = [...new Set(payload.map(doc => doc.data().service))]
			state.services = [...new Set([].concat(state.services, state.services2))]
			state.services.sort((a,b) => a < b ? -1 : 1)
			state.services = state.services.map(v=>v.toUpperCase())
		},
		setPricebook (state, payload) {
			state.pricebook.push({...payload.data(), id: payload.id})
		},
		setNewUser (state, payload) {
			state.newUser = payload
		},
		removeUser (state, payload) {
			state.users.splice(payload, 1)
		}
	},
	actions: {
		adminLogin({state, commit, dispatch}, payload){
			firebase.auth().currentUser.getIdTokenResult(true)
			.then((idTokenResult) => {
				// console.log('Token Claims: ', idTokenResult.claims)
       	// Confirm the user is a Super Admin.
       	if (!!idTokenResult.claims.superAdmin) {
       			// Show admin UI.
       			commit('setSuperAdmin', true)
       			commit('setAdmin', true)
       			// console.log('state user', state.user)
       		}
     		// Confirm the user is an Admin.
     		if (!!idTokenResult.claims.admin) {
       			// Show admin UI.
       			commit('setAdmin', true)
       		}
       		else {
       				// Show regular user UI.
       				commit('setSuperAdmin', false)
       			}
       		})
			.catch((error) => {
				console.log(error);
			});
		},
		signUserUp ({state, commit, dispatch}, payload) {
			commit('setLoading', true)
			commit('clearError')
			const newUser = {
				firstName: payload.firstName,
				lastName: payload.lastName,
				email: payload.email,
				cId: payload.cId,
				service: payload.service,
				admin: false
			}
			commit('setUser', newUser)
			firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
			.then(
				res => {
					commit('setUser', {...state.user, id: res.user.uid})
					db.collection('users').doc(res.user.uid).set(state.user)
					commit('setLoading', false)
					commit('signInDialog', false)
				}
				)
			.catch(
				error => {
					commit('setLoading', false)
					commit('setError', error)
					console.log(error)
					state.user = null
				}
				)
		},
		validateKey({state, commit, dispatch}, payload){
			commit('setLoading', true)
			commit('clearError')
			if (payload.cId === '' || payload.cId === undefined){
				commit('setLoading', false)
				commit('settingsDialog', false)
				commit('drawerMenu', false)
				dispatch('updateUser', payload)
			} 
			else {
				db.collection('company').doc(payload.cId).get().then((doc) => {
					if (doc.exists) {
						if (doc.data().plan === 'plan_H3Cg05UNHxlVgK' || doc.data().plan === 'plan_H3ChyQA8ioiY1J' || doc.data().plan === 'plan_H3Chx2jKuPUXXe'){
							// check if limited plan 
							let users = 0
							let limit = 0
							doc.data().plan === 'plan_H3Cg05UNHxlVgK' ? limit = 16 :
							doc.data().plan === 'plan_H3ChyQA8ioiY1J' ? limit = 26 :
							doc.data().plan === 'plan_H3Chx2jKuPUXXe' ? limit = 36 : limit = 0
							return db.collection('users').where('cId', '==', payload.cId).get().then(docs=>{
								docs.forEach(doc=>{
									users++
								})
							}).then(()=>{
								if ( users >= limit){
									commit('setLoading', false)
									commit('drawerMenu', false)
									commit('settingsDialog', false)
									// commit('signInDialog', false)
									commit('setSnack', `User Subscription Limit Reached.`)
									return null;
								} else {
									dispatch(payload.callBack, payload)	
								}
							}).catch(err=> console.log('error validating key'))
						}
						dispatch(payload.callBack, payload)	
					} else {
						commit('setSnack', "Key Not Found, Check That You've Entered Your Collaboration Key Correct")
						commit('setLoading', false)
					}
				})
				.catch(
					error => {
						commit('setLoading', false)
						commit('setError', error)
						console.log(error)
					}
					)
			}
		},
		signUserIn ({state, commit, dispatch}, payload) {
			commit('setLoading', true)
			commit('clearError')
			firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
			.then(
				res => {
					commit('setLoading', false)
					commit('signInDialog', false)
				}
				)
			.catch(
				error => {
					commit('setLoading', false)
					commit('setError', error)
					console.log(error)
				}
				)
		},
		getGroups ({commit, state}) {
			db.collection('groups').where('cId', '==', state.user.cId ).onSnapshot(snapshot=>{
				const changes = snapshot.docChanges()
				changes.forEach(change => {
					const Index = state.groups.map(x=> x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setGroups', change.doc)
					}
					if (change.type == 'removed'){
						commit('removeGroup', Index)
					}
					// test
					if (change.type == 'modified'){
						commit('updateGroup', {ind: Index, item: change.doc.data()})
					}
				})
			})
		},
		getPriceBook ({commit, state}) {
			db.collection('items').where('cId', '==', state.user.cId ).onSnapshot(snapshot=>{
				const changes = snapshot.docChanges()
				commit('setServices', snapshot.docs)

				changes.forEach(change => {
					const Index = state.pricebook.map(x=> x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setPricebook', change.doc)
					}
					if (change.type == 'removed'){
						commit('removeItem', Index)
					}
					// test
					if (change.type == 'modified'){
						commit('updateItem', {ind: Index, item: change.doc.data()})
					}
				})
			})
		},
		getImages ({state, commit}){
			// Get a reference to storage bucket
			let storage = firebase.storage();

			// Create a storage reference
			let storageRef = storage.ref();

			// Create a reference for the list
			let listRef = storageRef.child(`${state.user.cId}/${state.user.service}/`);
			
			listRef.listAll().then(function(res) {
				// console.log('response: ',res)
				res.items.forEach(function(itemRef) {
			    // All the items under listRef.
			    // console.log('itemref', itemRef)
			    itemRef.getDownloadURL().then((url)=> {
				  	// commit('setImages', {
				  	// 		title: itemRef.name, 
				  	// 		url: url,
				  	// 		group: 'IMAGES',
				  	// 		service: state.user.service
				  	// 	})
				  	// console.log('images-=-=-=-=-=-=', state.images)
				  })
			});
			}).catch(function(error) {
			  // Uh-oh, an error occurred!
			});
		},
		getAuth({state, commit, dispatch}, payload){
			// console.clear()
			if (state.company.customer){
				db.collection('subscriptions').where('customer', '==', state.company.customer).get()
				.then(docs => {
					return docs.forEach(doc=>{
						// console.log('company subscription doc:', doc.data())
						const expTime = doc.data().current_period_end
						const newTime = Math.round(Date.now() / 1000);
						const withTwoDays = 172800 + expTime;
						if (withTwoDays >= newTime){
							// if (expTime >= newTime){
								commit('createCompanyInfo', {...state.company, active: true, subscribed: true, current_period_end: expTime})
								// dispatch('getImages')
								dispatch('getGroups')
								dispatch('getPriceBook')
								dispatch('getDiscounts')
								dispatch('getUserPresets')
								dispatch('getHistory')
								dispatch('getAllUsers')
								dispatch('adminLogin')
								router.push('/options')
							} else {
								commit('createCompanyInfo', {...state.company, active: false, subscribed: false})
								router.push('/register')
								console.log('not subscribed')
							}
						})
				}).catch(error=>console.log('Auth Error', error))
			} else {
				commit('createCompanyInfo', {...state.company, active: false, subscribed: false})
				router.push('/register')
				console.log('not subscribed')
			}
		},
		getDiscounts ({state, commit}) {
			db.collection('discounts').where('cId', '==', state.user.cId).onSnapshot(snapshot=>{
				const DiscountChanges = snapshot.docChanges()
				DiscountChanges.forEach(change => {
					const Index = state.discounts.map(x => x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setDiscount', {...change.doc.data(), 'id': change.doc.id})
					}
					if (change.type == 'removed'){
						commit('removeDiscount', Index)
					}
				})
			})
		},
		getUserInfo ({state, commit, dispatch}, payload){
			if (state.user.id){
				db.collection('users').where('id', '==', state.user.id).get()
				.then(docs => {
					docs.forEach(doc => {
					// console.log('doc.data(): ', doc.data())
					// flow issues to resolve 
					commit('setUser', {...doc.data(), admin: false, superAdmin: false})
					commit('clearAll')
					return dispatch('getCompanyInfo')
				})
				})

			}
		},
		getUserPresets ({state, commit}) {
			db.collection('presets').where('userId', '==', state.user.id).onSnapshot(snapshot=>{
				const presetChanges = snapshot.docChanges()
				presetChanges.forEach(change => {
					const Index = state.presets.map(x=> x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setPresets', {...change.doc.data(), 'id': change.doc.id})
					}
					if (change.type == 'removed'){
						commit('removePreset', Index)
					}
				})
			})
		},
		getHistory ({state, commit}) {
			db.collection('history').where('userId', '==', state.user.id).onSnapshot(snapshot=>{
				const historyChanges = snapshot.docChanges()
				historyChanges.forEach(change => {
					const Index = state.history.map(x=> x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setHistory', {...change.doc.data(), 'id': change.doc.id})
					}
					if (change.type == 'removed'){
						commit('removeHistory', Index)
					}
					if (change.type == 'modified'){
						commit('updateHistory', {ind: Index, item: change.doc.data()})
					}
				})
			})
		},
		getAllUsers ({state, commit}){
			//check if admin

			db.collection('users').where('cId', '==', state.user.cId).onSnapshot(snapshot=>{
				const userChanges = snapshot.docChanges()
				userChanges.forEach(change=>{
					const Index = state.users.map(x => x.id ).indexOf(change.doc.id)
					if (change.type == 'added' && Index < 0){
						commit('setUsers', {...change.doc.data(), 'id': change.doc.id})
					}
					if (change.type == 'removed'){
						commit('removeUser', Index)
					}
					if (change.type == 'modified'){
						commit('updateUser', {ind: Index, item: change.doc.data()})
					}
				})
			})

		},
		updateUser ({state, commit, dispatch}) {
			commit('setLoading', true)
			commit('clearError')
			db.collection('users').doc(state.user.id).set({...state.user}).then(data => {
				commit('setLoading', false)
				commit('settingsDialog', false)
				commit('drawerMenu', false)
				// console.log('updateUser data after set()', data)
				dispatch('getUserInfo')
			})
		},
		updateCompanyInfo ({state, dispatch, commit, getters}, payload){
			commit('setLoading', true)
			commit('clearError')
			state.company.id == null ? dispatch('createCompanyInfo', payload) 
			: db.collection('company').doc(state.company.id).set({...state.company, image: null}).then(data => {
				commit('setLoading', false)
				commit('settingsDialog', false)
				commit('drawerMenu', false)
				// commit('e1', 3)
				// console.log(data)
			})
		},
		createCompanyInfo ({state, commit, getters, dispatch}, payload) {
			commit('setLoading', true)
			commit('clearError')
			const Company = {
				email: state.user.email,
				imageUrl: payload.imageUrl,
				companyName: payload.companyName,
				companyPhone: payload.companyPhone,
				companyWebsite: payload.companyWebsite,
				footer: payload.footer,
				emailMessage: payload.emailMessage,
				priceDisclosure: payload.priceDisclosure
			}
			let imageUrl
			let cId
			let ext
			db.collection('company').add(Company)
			.then((data) => {
				cId = data.id
				commit('setUser', {...state.user, cId: cId})
				commit('createCompanyInfo', {...Company, id: cId})
				db.collection('company').doc(state.company.id).set({...state.company})
				dispatch('updateUser')
				commit('setLoading', false)
				commit('settingsDialog', false)
			})
			.catch((error) => {
				console.log(error)
			})
		},
		getCompanyInfo ({state, commit, dispatch}){
			if(state.user.cId) {
				db.collection('company').where('id', '==', state.user.cId).get()
				.then(docs => {
					docs.forEach(doc => {
						commit('createCompanyInfo', doc.data())
					})
					dispatch('getAuth')
				}) 
			} else {
				console.log('no user.cId')
			}
		},
		autoSignIn ({commit, dispatch}, payload) {
			commit('setUser', {id: payload.uid})
			dispatch('getUserInfo')
		},
		logOut ({commit}) {
			firebase.auth().signOut().then(()=>{location.reload()})
			commit('setUser', null)
			commit('clearAll')
			router.push('/')
		},
		clearError ({commit}) {
			commit('clearError')
		},
		alert(payload){
			alert(payload)
		},
		windowPrint({state, commit}){
			commit('drawerMenu', false)
			setTimeout(()=> window.print(), 100)
		}
	},
	getters: {
		user (state) {
			return state.user
		},
		company (state) {
			return state.company
		},
		settingsDialog (state) {
			return state.settingsDialog
		},
		loading (state) {
			return state.loading
		},
		error (state) {
			return state.error
		},
		groups (state){
			return state.groups
		},
		drawerMenu (state){
			return state.drawerMenu
		},
		presets (state){
			return state.presets
		},
		history (state){
			return state.history
		},
		preview (state){
			return state.preview
		},
		pricebook (state){
			return state.pricebook
		},
		services (state){
			return state.services
		},
		groups (state){
			return state.groups
		},
		techName (state) {
			if (state.user !== null && state.user !== undefined){
				return `${state.user.firstName} ${state.user.lastName}`
			}
			else return ''
		},
	users (state){
		return state.users
	}
}
})
store.watch((state) => state.user, (user) => {

	if (!user || !user.id){
		// console.log('changing e1 to 1')
		store.commit('e1', 1)
	}
	else if (user && user.id && !user.cId){
		// console.log('changing e1 to 2')
		store.commit('e1', 2)
	}
	else if (user.cId){
		// console.log('changing e1 to 3')
		store.commit('e1', 3)
	}
})
